import React from 'react'
import { useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import { TbInfoTriangle, TbInfoTriangleFilled } from "react-icons/tb";
import infoimg from "../../../assets/images/all/infoimg.svg";

const MarketClose = (props) => {
  const game_name = useSelector((state) => state.CommonConfig.discount.game_name);
  const message = props.t('market_closed');
  const game_id = useSelector((state) => state.CommonConfig.game_id);

  const formattedMessage = message.replace(':game_name', game_name);

  const normalizeMessage = (message) => {
    return message
      .toLowerCase() // Make it case-insensitive
      .replace(/[^a-z]/g, ''); // Remove all non-alphanumeric characters (but keep numbers)
  };

  return (
    <div className='information-img'>
      <h2>{props.t('information')}</h2>
      {/* <img src={infoimg} /> */}
      <TbInfoTriangle className="info-icon" />
      {/* <TbInfoTriangleFilled className="info-icon"/> */}
      {/* <p>Pasaran Togel {game_name} sedang ditutup</p> */}
      {/* <p>
        {props.gameAllowed && props.gameAllowed.trim() !== ''
          ? normalizeMessage(props.gameAllowed) == 'blockaccount'
            ? dangerouslySetInnerHTML={{ __html: props.t('client_block_message') }} // hardcoded message
            : props.t('promotion_message') + " " + props.gameAllowed
          : formattedMessage}
      </p> */}


      {props.gameAllowed && props.gameAllowed.trim() !== '' ? (
        normalizeMessage(props.gameAllowed) === 'blockaccount' ? (
          <p dangerouslySetInnerHTML={{ __html: props.t('client_block_message') }} />
        ) : (
          <p>{props.t('promotion_message') + ' ' + props.gameAllowed}</p>
        )
      ) : (
        <p>{formattedMessage}</p>
      )}

      {/* <p>{props.gameAllowed && props.gameAllowed.trim() !== '' ? props.t('promotion_message') + " " + props.gameAllowed : formattedMessage}</p> */}
    </div>
  )
}

export default withTranslation()(MarketClose)
